import { DialogContentText, makeStyles } from "@material-ui/core"
// @ts-ignore
import { Link } from "react-router-dom"
import React, { useState } from "react"
import CustomCard from "./custom-card"
import {
  SaveIcon,
  CancelIcon,
  DuplicateIcon,
  unpinnedIcon,
  pinnedIcon,
  EditIcon,
} from "./icons-svg"
import ConfirmationModal from "./confirmation-modal"
import InputText from "./input-text"
import store from "src/store"
import moment from "moment"
import {
  cardContentStyle,
  cardInlineInfoStyle,
  cardTitleStyle as cardTitleStyle,
} from "./card-styles"
import { getLibraryURL } from "../utils/get-simulation-library-url"
import Tooltip from "./tooltip"
import copyToClipboard from "copy-to-clipboard"
import CustomModal from "./custom-modal"
import useIsLoggedIn from "src/utils/use-is-logged-in"
import consts from "shared/consts"
import Progress from "./progress"
import useFeature from "../utils/subscriptionWrapper"
import CompileDialogForReview from "./compileDialogForReview"
import InputTextarea from "./input-textarea"
import InputDropdown from "./input-dropdown"
import { InfoOutlined } from "@material-ui/icons"
import useHistory from "src/use-history"

const useStyles = makeStyles({
  root: {
    marginBottom: "8px",
    display: "flex",
    boxShadow: "none",
    padding: "20px",
    alignItems: "center",
  },
  child: {
    flex: "1",
    padding: "5px",
  },
  rowParent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
  content: {
    flex: "1 0 auto",
    height: "100%",
    padding: "0px !important",
  },
  rightIcon: {
    float: "right",
  },
  staticText: {
    color: "#717178",
  },
  icon: {
    display: "inline-block",
    fontSize: "18px",
    color: "#2E2E38",
    marginLeft: "5px",
  },
  clickable: {
    cursor: "pointer",
  },
})

export default function ReviewCard(props) {
  let REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS = useFeature(
    consts.FEATURE_FLAG_REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS,
  )
  const history = useHistory()

  const classes = useStyles()
  const { userInfo } = useIsLoggedIn()

  const defaultCopyTip = "Copy to clipboard"
  const [copyTip, setCopyTip] = useState(defaultCopyTip)

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [showEditReviewTitle, setShowEditReviewTitle] = useState(false)
  const [showEditReviewDescription, setShowEditReviewDescription] =
    useState(false)
  const [showEditReviewFileModal, setShowEditReviewFileModal] = useState(false)

  const [updatedReviewTitle, setUpdatedReviewTitle] = useState("")
  const [updatedReviewTitleHasError, setUpdatedReviewTitleHasError] =
    useState(false)
  const [updatedReviewTitleErrorText, setUpdatedReviewTitleErrorText] =
    useState("")

  const [updatedReviewDescription, setUpdatedReviewDescription] = useState("")

  const [showCopyFromTemplateModal, setShowCopyFromTemplateModal] =
    useState(false)
  const [copyFromTemplateId, setCopyFromTemplateId] = useState("")
  const [copyFromTemplateIdHasError, setCopyFromTemplateIdHasError] =
    useState(false)
  const [copyFromTemplateIdErrorText, setCopyFromTemplateIdErrorText] =
    useState("")
  const [copyFromTemplateInProgress, setCopyFromTemplateInProgress] =
    useState(false)
  const [analyzing, setAnalyzing] = useState(false)

  const deleteReview = () => {
    store.deleteReview(props.review._id)
    setShowDeleteConfirmation(false)
  }

  const showUpdateReviewTitleInput = () => {
    setUpdatedReviewTitle(props.review.name)
    setShowEditReviewTitle(true)
  }

  const showUpdateReviewDescriptionInput = () => {
    setUpdatedReviewDescription(props.review.description)
    setShowEditReviewDescription(true)
  }

  const cancelReviewTitleUpdate = () => {
    setUpdatedReviewTitle("")
    setUpdatedReviewTitleHasError(false)
    setUpdatedReviewTitleErrorText("")
    setShowEditReviewTitle(false)
  }

  const cancelReviewDescriptionUpdate = () => {
    setUpdatedReviewDescription("")
    setShowEditReviewDescription(false)
  }

  const onReviewTitleChange = (value) => {
    setUpdatedReviewTitle(value)

    if (!value) {
      setUpdatedReviewTitleHasError(true)
      setUpdatedReviewTitleErrorText("Review title is required")
    } else {
      setUpdatedReviewTitleHasError(false)
      setUpdatedReviewTitleErrorText("")
    }
  }

  const onReviewDescriptionChange = (value) => {
    setUpdatedReviewDescription(value)
  }

  const updateReview = (fieldName) => {
    let value = ""
    if (fieldName == "name") {
      if (updatedReviewTitleHasError) {
        return
      }
      value = updatedReviewTitle
      setShowEditReviewTitle(false)
    }

    if (fieldName == "description") {
      if (!updatedReviewDescription) {
        return
      }
      value = updatedReviewDescription
      setShowEditReviewDescription(false)
    }

    store.updateReview(fieldName, value, props.review._id)
  }

  const copy = () => {
    copyToClipboard(props.review._id)
    setCopyTip("Copied!")
    setTimeout(() => {
      try {
        // in timeout might be an error of updating unmounted component
        setCopyTip(defaultCopyTip)
      } catch (err) {
        const noop = function () {}
        noop() // eslint don't allow empty blocks
      }
    }, 2000)
  }

  const changePinStatus = (status) => {
    store.changePinReviewStatus(status, props.review._id)
    if (!store.pinUnpinInfoShowed) {
      store.pinUnpinInfoShowed = true
      store.updateStore()
    }
  }

  const getTemplateList = () => {
    let templateList = store.templates.map((review) => {
      return {
        label: review.name,
        value: review._id,
        disabled: false,
      }
    })
    return templateList
  }

  const onCopyFromTemplateModalClose = () => {
    setCopyFromTemplateIdHasError(false)
    setCopyFromTemplateId("")
    setCopyFromTemplateIdErrorText("")
    setShowCopyFromTemplateModal(false)
  }

  const onSubmitCopyFromTemplate = async () => {
    if (!copyFromTemplateId) {
      setCopyFromTemplateIdHasError(true)
      setCopyFromTemplateIdErrorText("Please select template")
    } else {
      setCopyFromTemplateInProgress(true)

      let reqBody = {
        copyFromTemplateId: copyFromTemplateId,
        copyToReviewId: props.review._id,
        engagementId: props.review.engagementData._id,
      }
      try {
        let response = await store.copyFromTemplate(reqBody)
        if (response && response.status) {
          store.showToaster("info", response.message)
        }
        onCopyFromTemplateModalClose()
      } catch (err) {
        console.log("Some error has occured while copying from template ", err)
      } finally {
        setCopyFromTemplateInProgress(false)
      }
    }
  }

  const getSelectedTemplateReviewDescription = () => {
    if (copyFromTemplateId) {
      let selectedTemplate = store.allMyReviews.find(
        (item) => item._id == copyFromTemplateId,
      )
      return (
        selectedTemplate["description"] && (
          <div>
            <b>initialization steps:</b>
            <br />
            {selectedTemplate["description"].split("\n").map((x, idx) => (
              <div key={idx}>{x || <br />}</div>
            ))}
          </div>
        )
      )
    } else {
      return ""
    }
  }

  const doAnalyze = async () => {
    setAnalyzing(true)
    await store.analyze(props.review._id)
    await store.invalidateReviewData(props.review._id)
    await store.updateMyReviewList()
    setAnalyzing(false)
  }

  const goToAIAgent = () => {
    let q = {}
    q.review_id = props.review._id
    q.engagement_id = props.review.engagementData._id
    q.show_architecture = false
    history.push(
      consts.SCR_APP_URLS.aiReviewAgent + "?" + require("qs").stringify(q),
    )
  }
  const goToAnalyzer = () => {
    let q = {}
    q.review_id = props.review._id
    q.engagement_id = props.review.engagementData._id
    q.show_architecture = false
    history.push(
      consts.SCR_APP_URLS.scAnalyzer + "?" + require("qs").stringify(q),
    )
  }

  const goToAskQuestion = () => {
    let q = {};
    q.review_id = props.review._id;
    q.engagement_id = props.review.engagementData._id;
    history.push(
      consts.SCR_APP_URLS.askQuestion + "?" + require("qs").stringify(q),
    )
  }

  return (
    <div
      css={`
        display: inline-block;
        margin-right: 10px;
      `}
    >
      <ConfirmationModal
        title="Delete review"
        message={"Are you sure you want to delete " + props.review.name + "?"}
        open={showDeleteConfirmation}
        onClose={() => {
          setShowDeleteConfirmation(false)
        }}
        confirmationBtnText="Delete review"
        onConfirm={() => {
          deleteReview()
        }}
      />

      <CustomModal
        size="medium"
        title="Copy from template"
        showModal={showCopyFromTemplateModal}
        onCloseModal={() => {
          setShowCopyFromTemplateModal(false)
        }}
        submitBtnText={"Copy"}
        onSubmit={(e) => {
          e.preventDefault()
          onSubmitCopyFromTemplate()
        }}
        submitBtnDisabled={copyFromTemplateInProgress}
      >
        <>
          <DialogContentText color="textPrimary">
            <div>Please select a template from which you want to copy.</div>
          </DialogContentText>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              onSubmitCopyFromTemplate()
            }}
          >
            <div css="margin-top: 15px;">
              <InputDropdown
                id={"copyFromTemplateId"}
                label={"Template"}
                value={copyFromTemplateId}
                disabled={false}
                onChange={(value) => {
                  setCopyFromTemplateId(value)
                }}
                list={getTemplateList()}
                hasError={copyFromTemplateIdHasError}
                errorText={copyFromTemplateIdErrorText}
              />
            </div>
          </form>
          <div css="padding-top: 15px;">
            {getSelectedTemplateReviewDescription()}
          </div>
          {copyFromTemplateInProgress && (
            <div css="margin-top: 15px; padding-bottom: 0px !important;">
              <Progress />
            </div>
          )}
        </>
      </CustomModal>
      <CustomCard className={classes.root}>
        <div
          css={`
            flex-grow: 1;
          `}
        >
          <div className={classes.rowParent}>
            <div
              css="    
                display: flex;
                align-items: flex-start;
                justify-content: space-between;"
            >
              <div css="width:100%">
                {showEditReviewTitle ? (
                  <form onSubmit={() => updateReview("name")}>
                    <div css="display: flex; align-items: center;">
                      <div css="width: 100%">
                        <InputText
                          id={"editReviewTitle"}
                          value={updatedReviewTitle}
                          onChange={(value) => {
                            onReviewTitleChange(value)
                          }}
                          hasError={updatedReviewTitleHasError}
                          errorText={updatedReviewTitleErrorText}
                        />
                      </div>
                      <div>
                        <span
                          className={`${classes.icon} ${classes.clickable}`}
                          onClick={() => {
                            updateReview("name")
                          }}
                        >
                          {SaveIcon}
                        </span>
                      </div>
                      <div>
                        <span
                          className={`${classes.icon} ${classes.clickable}`}
                          onClick={() => {
                            cancelReviewTitleUpdate()
                          }}
                        >
                          {CancelIcon}
                        </span>
                      </div>
                    </div>
                  </form>
                ) : (
                  <div
                    css="    
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;"
                  >
                    <div
                      css={`
                        color: inherit;
                        text-decoration: inherit;
                        font-size: 18px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .btn {
                          visibility: hidden;
                        }
                        :hover .btn {
                          visibility: visible;
                        }
                      `}
                    >
                      {props.review.name}

                      <div
                        className={`${classes.icon} ${classes.clickable} btn`}
                        onClick={() => {
                          showUpdateReviewTitleInput()
                        }}
                      >
                        <Tooltip tip={"Edit review title"}>
                          {EditIcon(20)}
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div>
                {props.review.isPinned ? (
                  <Tooltip tip={"Unpin from sidemenu"}>
                    <div
                      className={`${classes.icon} ${classes.clickable}`}
                      onClick={() => {
                        changePinStatus(false)
                      }}
                    >
                      {pinnedIcon()}
                    </div>
                  </Tooltip>
                ) : (
                  <Tooltip tip={"Pin to sidemenu"}>
                    <div
                      className={`${classes.icon} ${classes.clickable}`}
                      onClick={() => {
                        changePinStatus(true)
                      }}
                    >
                      {unpinnedIcon()}
                    </div>
                  </Tooltip>
                )}
              </div>
            </div>

            <div css={cardInlineInfoStyle}>
              <div css={cardContentStyle + "width: 100%;"}>
                <div
                  css="    
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    width: 100%;"
                >
                  {showEditReviewDescription ? (
                    <form
                      onSubmit={() => updateReview("description")}
                      css="width: 100%;"
                    >
                      <div css="display: flex; align-items: center;">
                        <div css="width: 100%">
                          <InputTextarea
                            id={"editReviewTitle"}
                            rows={4}
                            value={updatedReviewDescription}
                            onChange={(value) => {
                              onReviewDescriptionChange(value)
                            }}
                          />
                        </div>
                        <div>
                          <span
                            className={`${classes.icon} ${classes.clickable}`}
                            onClick={() => {
                              updateReview("description")
                            }}
                          >
                            {SaveIcon}
                          </span>
                        </div>
                        <div>
                          <span
                            className={`${classes.icon} ${classes.clickable}`}
                            onClick={() => {
                              cancelReviewDescriptionUpdate()
                            }}
                          >
                            {CancelIcon}
                          </span>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div
                      css={`
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .btn {
                          visibility: hidden;
                        }
                        :hover .btn {
                          visibility: visible;
                        }
                      `}
                    >
                      <div>
                        {props.review.description ? (
                          <>
                            {props.review.description
                              .split("\n")
                              .map((x, idx) => (
                                <div key={idx}>{x || <br />}</div>
                              ))}
                          </>
                        ) : (
                          "No description"
                        )}
                      </div>

                      <div
                        className={`${classes.icon} ${classes.clickable} btn`}
                        onClick={() => {
                          showUpdateReviewDescriptionInput()
                        }}
                      >
                        <Tooltip tip={"Edit review description"}>
                          {EditIcon(20)}
                        </Tooltip>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div css={cardInlineInfoStyle}>
              <div css={cardTitleStyle}>Review ID:</div>
              <div css={cardContentStyle}>{props.review._id}</div>
              <div css={cardContentStyle}>
                <Tooltip tip={copyTip}>
                  <span
                    className={`${classes.icon} ${classes.clickable}`}
                    onClick={() => {
                      copy()
                    }}
                  >
                    {DuplicateIcon()}
                  </span>
                </Tooltip>
              </div>
            </div>

            <div css={cardInlineInfoStyle}>
              <div css={cardTitleStyle}>Engagement ID:</div>
              {!userInfo?.auth0Subscripton && props.review.organizationData ? (
                <div css={cardContentStyle}>
                  {props.review.organizationData.name} /
                  {props.review.engagementData.engId}
                </div>
              ) : (
                <div css={cardContentStyle}>
                  {props.review.engagementData.engId}
                </div>
              )}
            </div>

            <div css={cardInlineInfoStyle}>
              <div css={cardTitleStyle}>Created:</div>
              <div css={cardContentStyle}>
                {moment(props.review.created_on).format("MM-DD-YYYY | hh:mm A")}
              </div>
            </div>
            <div css={cardInlineInfoStyle}>
              <div css={cardTitleStyle}>
                <Link
                  to={getLibraryURL({
                    engagement_id: props.review.engagementData._id,
                    review_id: props.review._id,
                  })}
                >
                  Go to simulations
                </Link>
              </div>
            </div>
            <div css={cardInlineInfoStyle}>
              <div
                css={`
                  cursor: pointer;
                  color: blue;
                  text-decoration: underline;
                `}
                onClick={() => store.showEditReviewFileModal(props.review._id)}
              >
                Edit Review Files
              </div>
            </div>
            {window["config"].SHOW_ANALYZER === "YES" ? (
              <>
                {props.review["analyzedData"] ? (
                  <>
                    <div css={cardInlineInfoStyle}>
                      <>
                        {analyzing ? (
                          <div
                            css={`
                              color: blue;
                            `}
                          >
                            Analyzing...
                          </div>
                        ) : (
                          <div
                            css={`
                              cursor: pointer;
                              color: blue;
                              text-decoration: underline;
                            `}
                            onClick={() => {
                              doAnalyze()
                            }}
                          >
                            Re-Analyze for the resource inspector
                          </div>
                        )}
                      </>
                    </div>
                    {!analyzing && (
                      <div css={cardInlineInfoStyle}>
                        <div
                          css={`
                            cursor: pointer;
                            color: blue;
                            text-decoration: underline;
                          `}
                          onClick={() => {
                            goToAnalyzer()
                          }}
                        >
                          Show analyzer
                        </div>
                      </div>
                    )}                    
                  </>
                ) : (
                  <div css={cardInlineInfoStyle}>
                    {props.review["mainFileName"] ? (
                      <>
                        {analyzing ? (
                          <div
                            css={`
                              color: blue;
                            `}
                          >
                            Analyzing...
                          </div>
                        ) : (
                          <div
                            css={`
                              cursor: pointer;
                              color: blue;
                              text-decoration: underline;
                            `}
                            onClick={() => {
                              doAnalyze()
                            }}
                          >
                            Analyze for the resource inspector
                          </div>
                        )}
                      </>
                    ) : (
                      <div
                        css={`
                          cursor: not-allowed;
                          color: grey;
                          display: flex;
                          align-items: center;
                          justify-content: flex-start;
                        `}
                      >
                        <div css="text-decoration:underline;">
                          Analyze for the resource inspector
                        </div>
                        &nbsp;
                        {
                          <Tooltip
                            css="padding: 0px;
                                line-height: 1;"
                            tip={"No review file available"}
                          >
                            <InfoOutlined
                              style={{ color: "#000", fontSize: "20px" }}
                            />
                          </Tooltip>
                        }
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : null}
            <div css={cardInlineInfoStyle}>
              {props.review["mainFileName"] ? (
                <div
                  css={`
                    cursor: pointer;
                    color: blue;
                    text-decoration: underline;
                  `}
                  onClick={() => {
                    goToAskQuestion()
                  }}
                >
                  Ask question (AI)
                </div>
              ) : (
                <div
                  css={`
                    cursor: not-allowed;
                    color: grey;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                  `}
                >
                  <div css="text-decoration:underline;">Ask question (AI)</div>
                  &nbsp;
                  {
                    <Tooltip
                      css="padding: 0px;
                        line-height: 1;"
                      tip={"No review file available"}
                    >
                      <InfoOutlined
                        style={{ color: "#000", fontSize: "20px" }}
                      />
                    </Tooltip>
                  }
                </div>
              )}
            </div>
          </div>
        </div>
      </CustomCard>
      {showEditReviewFileModal && (
        <CompileDialogForReview
          reviewId={props.review._id}
          requestClose={() => {
            store.invalidateReviewAbiCache(props.review._id)
            setShowEditReviewFileModal(false)
          }}
        />
      )}
    </div>
  )
}
